/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import AppointmentDataContent from "components/content/NewAppointmentDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";

/**
 * New appointment creation page.
 * Provides comprehensive appointment scheduling interface.
 * 
 * Features:
 * - Patient selection with search
 * - Provider/doctor selection
 * - Facility and resource selection
 * - Date and time picker
 * - Appointment type selection
 * - Reason for visit entry
 * - Duration configuration
 * - Recurring appointment setup
 * - Form validation
 * - Integration with calendar system
 * - Conflict detection
 * 
 * @returns {JSX.Element} New appointment page component
 */
const NewAppointmentPage = () => {
  return (
    <DefaultDashboardLayout>
      <AppointmentDataContent />
    </DefaultDashboardLayout>
  );
};

export default NewAppointmentPage;

